/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Fade from 'react-reveal/Fade';
import { inject, observer } from 'mobx-react';

import { ArticleSlide as ArticleSlideModel } from 'models';
import { FADE_VALUES } from 'animations/Animations';

import ArticleImage from './ArticleImage';
import StyledLink from './StyledLink';
import Title from './Title';

@inject("windowStore")
@observer
export default class ArticleSlide extends Component {
  render() {
    const {
      article: { image, title, url },
      index,
      windowStore,
    } = this.props;

    return (
      <Fade
        bottom
        distance={`${FADE_VALUES.BOX.LARGE}`}
        delay={
          windowStore.isOnMobile
            ? FADE_VALUES.DELAY.SMALL
            : FADE_VALUES.DELAY.SMALL * index
        }
      >
        <StyledLink href={url} rel="nofollow">
          <ArticleImage src={windowStore.adjustImageSize(image)} />
          <Title>
            {title}
          </Title>
        </StyledLink>
      </Fade>
    );
  }
}

ArticleSlide.propTypes = {
  article: PropTypes.instanceOf(ArticleSlideModel).isRequired,
  index: PropTypes.number.isRequired,
};



// WEBPACK FOOTER //
// ./src/kentico-blocks/ArticleSlider/ArticleSlide/index.jsx